import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class TasUnaccreditedInstitutionModel extends Model {
  @attr declare address: string;
  @attr declare locationName: string;
  @attr declare locationType: string;

  [Type] = 'tas-unaccredited-institution' as const;
}
